var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWizzardBtnChevPrev(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18l-6-6 6-6",
    stroke: "url(#wizzard-btn-chev-prev_svg__paint0_linear_7332_13809)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19 18l-6-6 6-6",
    stroke: "url(#wizzard-btn-chev-prev_svg__paint1_linear_7332_13809)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wizzard-btn-chev-prev_svg__paint0_linear_7332_13809",
    x1: 12,
    y1: 6,
    x2: 4.536,
    y2: 7.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E62E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wizzard-btn-chev-prev_svg__paint1_linear_7332_13809",
    x1: 19,
    y1: 6,
    x2: 11.536,
    y2: 7.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E62E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5630"
  })))));
}
export default __webpack_public_path__ + "static/wizzard-btn-chev-prev.76fae1fc.svg";
export { SvgWizzardBtnChevPrev as ReactComponent };